






































































































































































































































































































































































































































































































































































import Vue from 'vue'
import PeriodSelector from '@/components/PeriodSelector.vue'
import { DatePeriod } from '@/model/DatePeriod'
import { DatePeriodEnum, SecurityArea, SecurityComponent, ShiftFilterScope } from '@/types/enums'
import { GET_IS_CAPELO, GET_SECURITY_LEVEL, SCHEDULING_GET_PARAMETERS } from '@/store/getter-types'
import { SchedulerSettings } from '@/model/planning/SchedulerSettings'
import * as securityService from '@/services/security-service'
import SearchFilterDialog from '@/components/planning/SearchFilterDialog.vue'

interface ComponentData {
  isSelectProjectSerieActive: boolean
  isAddressFilterActive: boolean
  isProjectFilterActive: boolean
  isAboFilterActive: boolean
  isPeriodTypeYear: boolean
  isPeriodTypeMonth: boolean
  isPeriodTypeWeek: boolean
  isPeriodTypeWorkingWeek: boolean
  isPeriodTypeDay: boolean
  period: String
  isDisabledEditShiftButtons: boolean
  isDisabledDeleteShiftButtons: boolean
  isDisabledAutoPlanningButton: boolean
  isDisabledFixedButton: boolean
  isDisabledCompleteButton: boolean
  isDisabledActivateButton: boolean
  isDisabledDeactivateButton: boolean
  displaySearchMenu: boolean
  isFilterActive: boolean
  filterSearchString: string | null
  filterScope: ShiftFilterScope
  panel: number[]
  displayNoteMenu: boolean
  displaySettingsMenu: boolean
  showEmployeeNote: boolean
  additionalServicesList: any[]
  displayAdditionalServicesMenu: boolean
  timerId: any
}

export default Vue.extend({
  name: 'SchedulerToolbar',

  components: {
    PeriodSelector,
    SearchFilterDialog
  },

  props: {
    drawer: Boolean,
    isFastPlanningDisabled: Boolean,
    isCalendarEventDisabled: Boolean,
    calendarEventButtonInactive: Boolean,
    selectedShift: Object as () => any,
    selectedCalendarEvent: Object as () => any,
    checkedList: Array as () => any,
    yearPeriodScrollDate: Date,
    isFastPlanningActive: Boolean,
    isCalendarEventActive: Boolean,
    isMonthStatisticActive: Boolean,
    isMonthStatisticDisabled: Boolean,
    isEditShiftNoteDisabled: Boolean,
    isEditEmployeeNoteDisabled: Boolean,
    schedulerSettings: Array as () => SchedulerSettings[],
    isAdditionalServicesDisabled: Boolean,
    showWeekPeriod: Boolean,
    isProjectFilterDisabled: Boolean,
    isAboFilterDisabled: Boolean
  },

  data (): ComponentData {
    return {
      isSelectProjectSerieActive: false,
      isAddressFilterActive: false,
      isProjectFilterActive: false,
      isAboFilterActive: false,
      isPeriodTypeYear: false,
      isPeriodTypeMonth: false,
      isPeriodTypeWeek: false,
      isPeriodTypeWorkingWeek: false,
      isPeriodTypeDay: false,
      period: DatePeriodEnum.Month,
      isDisabledEditShiftButtons: true,
      isDisabledDeleteShiftButtons: true,
      isDisabledAutoPlanningButton: true,
      isDisabledFixedButton: true,
      isDisabledCompleteButton: true,
      isDisabledActivateButton: true,
      isDisabledDeactivateButton: true,
      displaySearchMenu: false,
      isFilterActive: false,
      filterSearchString: null,
      filterScope: ShiftFilterScope.AllShifts,
      panel: [],
      displayNoteMenu: false,
      displaySettingsMenu: false,
      showEmployeeNote: false,
      additionalServicesList: [
        {id: 1, code: 1, label: this.$t('planningPage.productsServices').toString()},
        //{id: 2, code: 2, label: 'Freie Position'},
        {id: 3, code: 3, label: this.$t('planningPage.expensesProvision').toString()},
        {id: 4, code: 4, label: this.$t('planningPage.discounts').toString()}
      ],
      displayAdditionalServicesMenu: false,
      timerId: undefined
    }
  },

  watch: {
    displaySearchMenu (newVal: boolean): void {
      let data: any = this.getRouteData()

      data.displaySearchMenu = newVal
      this.$router.push({name: 'planning', query: { data: JSON.stringify(data) }})
    },

    checkedList (newVal): void {
      if(newVal.length > 0) {
        this.isDisabledAutoPlanningButton = false
        this.isDisabledDeleteShiftButtons = false
        this.isDisabledFixedButton = false
        this.isDisabledCompleteButton = false
        this.isDisabledActivateButton = false
        this.isDisabledDeactivateButton = false
      } else {
        this.isDisabledAutoPlanningButton = true
        this.isDisabledDeleteShiftButtons = true
        this.isDisabledFixedButton = true
        this.isDisabledCompleteButton = true
        this.isDisabledActivateButton = true
        this.isDisabledDeactivateButton = true
      }
    },

    isFastPlanningDisabled (newVal): void {
      if (newVal) {
        this.$emit('activateFastPlanning', false)
      }
    },

    isCalendarEventDisabled (newVal): void {
      if (newVal) {
        this.$emit('activateCalendarEvent', false)
      }
    },

    calendarEventButtonInactive (newVal): void {
      this.$emit('activateCalendarEvent', false)
    },

    selectedShift (newVal: any): void {
      if (newVal) {
        this.isDisabledAutoPlanningButton = false
        this.isDisabledEditShiftButtons = false
        this.isDisabledDeleteShiftButtons = false
        this.isDisabledFixedButton = false
        this.isDisabledCompleteButton = false
        this.isDisabledActivateButton = false
        this.isDisabledDeactivateButton = false
      } else {
        this.isDisabledEditShiftButtons = true
        //this.isDisabledDeleteShiftButtons = true
        if(this.checkedList.length > 0) {
          this.isDisabledAutoPlanningButton = false
          this.isDisabledFixedButton = false
          this.isDisabledCompleteButton = false
          this.isDisabledActivateButton = false
          this.isDisabledDeactivateButton = false
          this.isDisabledDeleteShiftButtons = false
        } else {
          this.isDisabledAutoPlanningButton = true
          this.isDisabledFixedButton = true
          this.isDisabledCompleteButton = true
          this.isDisabledActivateButton = true
          this.isDisabledDeactivateButton = true
          this.isDisabledDeleteShiftButtons = true
        }
      }
    },

    selectedCalendarEvent (newVal: any): void {
      if (newVal) {
        if(this.securityLevel !== 7) {
          this.isDisabledEditShiftButtons = false
          this.isDisabledDeleteShiftButtons = false
        } else {
          if(newVal.category === 2) {
            this.isDisabledEditShiftButtons = false
            this.isDisabledDeleteShiftButtons = false
          }
        }
      } else if (!this.selectedShift && this.checkedList.length === 0) {
        this.isDisabledEditShiftButtons = true
        this.isDisabledDeleteShiftButtons = true
      }
    },

    filterScope (): void {
      if (this.filterScope === ShiftFilterScope.AllShifts) {
        if (this.filterSearchString && this.filterSearchString.length > 0) {
          this.isFilterActive = true
        } else {
          this.isFilterActive = false
        }
      } else {
        this.isFilterActive = true
      }
      this.$emit('filterScopeChange', this.filterScope)

      let data: any = this.getRouteData()

      data.filterScope = this.filterScope
      this.$router.push({name: 'planning', query: { data: JSON.stringify(data) }})
    },

    filterSearchString (newVal: any): void {
      if (newVal && newVal.length > 0) {
        this.isFilterActive = true
      } else {
        if (this.filterScope === ShiftFilterScope.AllShifts) {
          this.isFilterActive = false
        } else {
        }
      }

      clearTimeout(this.timerId)

      this.timerId = setTimeout(() => {
        this.$emit('filterSearchString', newVal)

        let data: any = this.getRouteData()

        data.filterSearchString = newVal
        this.$router.push({name: 'planning', query: { data: JSON.stringify(data) }})
      }, 500)

    },

    showWeekPeriod (newVal: boolean): void {
      if(newVal) {
        this.onWeekPeriodClick()
      } else {
        this.onMonthPeriodClick()
      }
    },

    isProjectFilterDisabled (newVal: boolean): void {
      if(!newVal) {
        this.isProjectFilterActive = false
        this.$emit('showShiftWithSelectedProject', this.isProjectFilterActive)
      }
    },

    isAboFilterDisabled (newVal: boolean): void {
      if(!newVal) {
        this.isAboFilterActive = false
        this.$emit('showShiftWithSelectedAbo', this.isAboFilterActive)
      }
    }
  },

  computed: {
    projectSerieColor (): string {
      return this.isSelectProjectSerieActive ? 'primary' : 'secondary'
    },

    monthStatisticColor (): string {
      return this.isMonthStatisticActive ? 'primary' : 'secondary'
    },

    addressFilterColor (): string {
      return this.isAddressFilterActive ? 'primary' : 'secondary'
    },

    projectFilterColor (): string {
      return this.isProjectFilterActive ? 'primary' : 'secondary'
    },

    aboFilterColor (): string {
      return this.isAboFilterActive ? 'primary' : 'secondary'
    },

    periodTypeYearColor (): string {
      return this.period === DatePeriodEnum.Year ? 'primary' : 'secondary'
    },

    periodTypeMonthColor (): string {
      return this.period === DatePeriodEnum.Month ? 'primary' : 'secondary'
    },

    periodTypeWeekColor (): string {
      return this.period === DatePeriodEnum.Week ? 'primary' : 'secondary'
    },

    periodTypeWorkingWeekColor (): string {
      return this.period === DatePeriodEnum.WorkingWeek ? 'primary' : 'secondary'
    },

    periodTypeDayColor (): string {
      return this.period === DatePeriodEnum.Day ? 'primary' : 'secondary'
    },

    fastPlanningFilterColor (): string {
      return this.isFastPlanningActive ? 'primary' : 'secondary'
    },

    calendarEventColor (): string {
      return this.isCalendarEventActive ? 'primary' : 'secondary'
    },

    setToolbarHeight (): string {
      if(this.$vuetify.breakpoint.smOnly) {
        return '120px'
      } else if (this.$vuetify.breakpoint.xsOnly) {
        return '200px'
      } else {
        return '48px'
      }
    },

    filterIconColor (): string {
      return this.isFilterActive ? 'primary' : 'secondary'
    },

    securityLevel (): number | undefined {
      return this.$store.getters[GET_SECURITY_LEVEL]
    },

    isCapelo (): boolean {
      return this.$store.getters[GET_IS_CAPELO]
    },
    showIconAddress (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.IconAddress)
    },

    showIconProject (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.IconProject)
    },

    showIconAbo (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.IconAbo)
    },

    showIconSchedule (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.IconFastPlanning)
    },

    isDisabledIconSchedule (): boolean {
      return securityService.isDisabled(SecurityArea.PlanningBar, SecurityComponent.IconFastPlanning)
    },

    showIconCalenderArt (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.IconKalenderArt)
    },

    isDisabledIconCalenderArt (): boolean {
      return securityService.isDisabled(SecurityArea.PlanningBar, SecurityComponent.IconKalenderArt)
    },

    showIconInsert (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.IconInsert)
    },

    isDisabledIconInsert (): boolean {
      return securityService.isDisabled(SecurityArea.PlanningBar, SecurityComponent.IconInsert)
    },

    showIconUpdate (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.IconUpdate)
    },

    isDisabledIconUpdate (): boolean {
      return securityService.isDisabled(SecurityArea.PlanningBar, SecurityComponent.IconUpdate)
    },

    showIconDelete (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.IconDelete)
    },

    isDisabledIconDelete (): boolean {
      return securityService.isDisabled(SecurityArea.PlanningBar, SecurityComponent.IconDelete)
    },

    showIconSidebar (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.IconSidebar)
    },

    isDisabledIconSidebar (): boolean {
      return securityService.isDisabled(SecurityArea.PlanningBar, SecurityComponent.IconSidebar)
    },

    showIconSearch (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.IconSearch)
    },

    isDisabledIconSearch (): boolean {
      return securityService.isDisabled(SecurityArea.PlanningBar, SecurityComponent.IconSearch)
    },

    showIconSchedulerSettings (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.SchedulerSettings)
    },

    isDisabledIconSchedulerSettings (): boolean {
      return securityService.isDisabled(SecurityArea.PlanningBar, SecurityComponent.SchedulerSettings)
    },

    showIconAdditionalProducts (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.AdditionalProducts)
    },

    isDisabledIconAdditionalProducts (): boolean {
      return securityService.isDisabled(SecurityArea.PlanningBar, SecurityComponent.AdditionalProducts)
    },

    showIconSetInactive (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.SetInactive)
    },

    isDisabledIconSetInactive (): boolean {
      return securityService.isDisabled(SecurityArea.PlanningBar, SecurityComponent.SetInactive)
    },

    showIconSetActive (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.SetActive)
    },

    isDisabledIconSetActive (): boolean {
      return securityService.isDisabled(SecurityArea.PlanningBar, SecurityComponent.SetActive)
    },

    showIconSetClosed (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.SetClosed)
    },

    isDisabledIconSetClosed (): boolean {
      return securityService.isDisabled(SecurityArea.PlanningBar, SecurityComponent.SetClosed)
    },

    showIconInvoicing (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.Invoicing)
    },

    isDisabledIconInvoicing (): boolean {
      return securityService.isDisabled(SecurityArea.PlanningBar, SecurityComponent.Invoicing)
    },

    /*showIconAddressNote (): boolean {
      return securityService.isVisible(SecurityArea.Menu, SecurityComponent.Address)
    },

    isDisabledIconAddressNote (): boolean {
      return securityService.isDisabled(SecurityArea.Menu, SecurityComponent.Address)
    },*/

    showToolbarFunctions (): boolean {
      return securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.ToolbarFunctions)
    },
  },

  methods: {
    onPeriodSelected (value: DatePeriod): void {
      this.$emit('periodSelected', value)
    },

    yearPeriodChangeDate (value: string) {
      this.$emit('yearPeriodChangeDate', value)
    },

    onMonthStatisticClick (): void {
      this.$emit('showMonthStatistic', !this.isMonthStatisticActive)
    },

    onAddressFilterClick (): void {
      this.isAddressFilterActive = !this.isAddressFilterActive
      this.$emit('showShiftWithSelectedAddress', this.isAddressFilterActive)
    },

    onProjectFilterClick (): void {
      this.isProjectFilterActive = !this.isProjectFilterActive
      this.$emit('showShiftWithSelectedProject', this.isProjectFilterActive)
    },

    onAboFilterClick (): void {
      this.isAboFilterActive = !this.isAboFilterActive
      this.$emit('showShiftWithSelectedAbo', this.isAboFilterActive)
    },

    onSchedulerSettingsChange (item: SchedulerSettings): void {
      this.$emit('schedulerSettingsChange', item)
      if(item.code === 'FULLD' && !item.value && item.children[0]) {
        //@ts-ignore
        item.children.splice(0, 1, { code: item.children[0].code, value2: '1', description: item.children[0].description, children: item.children[0].children})
        this.$emit('schedulerSettingsChange', item.children[0])
      }
    },

    onYearPeriodClick (): void {
      this.period = DatePeriodEnum.Year
      this.isPeriodTypeYear = true
      this.isPeriodTypeMonth = false
      this.isPeriodTypeWeek = false
      this.isPeriodTypeWorkingWeek = false
      this.isPeriodTypeDay = false
    },

    onMonthPeriodClick (): void {
      this.period = DatePeriodEnum.Month
      this.isPeriodTypeYear = false
      this.isPeriodTypeMonth = true
      this.isPeriodTypeWeek = false
      this.isPeriodTypeWorkingWeek = false
      this.isPeriodTypeDay = false
    },

    onWeekPeriodClick (): void {
      this.period = DatePeriodEnum.Week
      this.isPeriodTypeYear = false
      this.isPeriodTypeMonth = false
      this.isPeriodTypeWeek = true
      this.isPeriodTypeWorkingWeek = false
      this.isPeriodTypeDay = false
    },

    onWorkingWeekPeriodClick (): void {
      this.period = DatePeriodEnum.WorkingWeek
      this.isPeriodTypeYear = false
      this.isPeriodTypeMonth = false
      this.isPeriodTypeWeek = false
      this.isPeriodTypeWorkingWeek = true
      this.isPeriodTypeDay = false
    },

    onDayPeriodClick (): void {
      this.period = DatePeriodEnum.Day
      this.isPeriodTypeYear = false
      this.isPeriodTypeMonth = false
      this.isPeriodTypeWeek = false
      this.isPeriodTypeWorkingWeek = false
      this.isPeriodTypeDay = true
    },

    onAddShiftClick (): void {
      this.$emit('addNewShift')
    },

    onEditShiftClick (): void {
      if(this.selectedShift) {
        this.$emit('editShift')
      } else if(this.selectedCalendarEvent) {
        this.$emit('editCalendarEvent')
      }
    },

    onDeleteShiftClick (): void {
      this.$emit('deleteShift')
    },

    onFixedButtonClick (): void {
      this.$emit('fixShift')
    },

    onCompleteButtonClick (): void {
      this.$emit('completeShift')
    },

    onActivateButtonClick (): void {
      this.$emit('activateShift')
    },

    onDeactivateButtonClick (): void {
      this.$emit('deactivateShift')
    },

    onToggleShiftsDrawer (): void {
      this.$emit('toggleShiftDrawer')
    },

    onFastPlanningClick (): void {
      this.$emit('activateFastPlanning', !this.isFastPlanningActive)
    },

    onCalendarEventClick (): void {
      this.$emit('activateCalendarEvent', !this.isCalendarEventActive)
    },

    onCalendarEventStepperClick (): void {
      this.$emit('openCalendarEventStepper')
    },

    onAutoPlanningButtonClick (): void {
      this.$emit('autoPlanning')
    },

    onProjectSerieClick (): void {
      this.isSelectProjectSerieActive = !this.isSelectProjectSerieActive
      this.$emit('activateSelectProjectSerie', this.isSelectProjectSerieActive)
    },

    onEditNote (item: number) {
      this.$emit('onEditNote', item)
      this.displayNoteMenu = false
    },

    onInvoicingClick (): void {
      this.$emit('showInvoicingDialog')
    },

    onAdditionalServicesClick (item: any): void {
      this.$emit('showAdditionalServicesDialog', item)
      this.displayAdditionalServicesMenu = false
    },

    onFilterSearchStringChange (item: string | null) {
      this.filterSearchString = item
    },

    onFilterScopeChange (item: ShiftFilterScope) {
      this.filterScope = item
    },

    onDisplaySearchMenu (): void {
      this.displaySearchMenu = !this.displaySearchMenu
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()
      let schedulingData: any = this.$store.getters[SCHEDULING_GET_PARAMETERS]

      if(data && data.currentPeriod && data.currentPeriod.period) {
        this.period = data.currentPeriod.period
      } else if(schedulingData && schedulingData.data && schedulingData.data.currentPeriod && schedulingData.data.currentPeriod.period) {
        this.period = schedulingData.data.currentPeriod.period
      } else {
        this.period = DatePeriodEnum.Month
      }

      this.isPeriodTypeYear = this.period === DatePeriodEnum.Year
      this.isPeriodTypeMonth = this.period === DatePeriodEnum.Month
      this.isPeriodTypeWeek = this.period === DatePeriodEnum.Week
      this.isPeriodTypeWorkingWeek = this.period === DatePeriodEnum.WorkingWeek
      this.isPeriodTypeDay = this.period === DatePeriodEnum.Day
      this.displaySearchMenu = data && data.displaySearchMenu ? data.displaySearchMenu : false
      this.filterSearchString = data && data.filterSearchString ? data.filterSearchString : null
      this.filterScope = data && data.filterScope ? data.filterScope : ShiftFilterScope.AllShifts
    }
  },

  created (): void {
    this.setDataFromRoute()

    if(!this.showIconSearch || !this.showToolbarFunctions) {
      this.filterScope = ShiftFilterScope.FixedShifts
    }
  }
})
